module.exports = __webpack_public_path__ + "img/pan.07613e22.png";